import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6" }
const _hoisted_4 = { class: "card border-0 rounded-0 bg-white authentication-card" }
const _hoisted_5 = { class: "card-body letter-spacing" }
const _hoisted_6 = { class: "fw-bold mb-0" }
const _hoisted_7 = { class: "mb-0 fs-md-15 fs-lg-16 text-paragraph sub-text" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20" }
const _hoisted_9 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_10 = ["title", "placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20" }
const _hoisted_13 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_14 = ["title", "placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20" }
const _hoisted_17 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_18 = ["title", "placeholder"]
const _hoisted_19 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20" }
const _hoisted_21 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_22 = {
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20" }
const _hoisted_26 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_27 = ["title", "placeholder"]
const _hoisted_28 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_29 = { class: "text-center mt-15 mt-sm-20 mt-md-25" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-arrow-left" }, null, -1 /* HOISTED */)
const _hoisted_31 = { class: "row justify-content-center" }
const _hoisted_32 = { class: "col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6" }
const _hoisted_33 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('feature.auth.request_support')), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('feature.auth.$request_support.message')), 1 /* TEXT */),
              _createElementVNode("form", {
                onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                _createCommentVNode(" EMAIL "),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    title: _ctx.$t('form.email.label'),
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && !_ctx.email_is_valid(_ctx.form.email) && _ctx.errors?.email }]]),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                    placeholder: _ctx.$t('form.email.placeholder'),
                    required: "",
                    pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+"
                  }, null, 10 /* CLASS, PROPS */, _hoisted_10), [
                    [_vModelText, _ctx.form.email]
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.email ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.email, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" FIRST NAME "),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('form.first_name.label')), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    title: _ctx.$t('form.first_name.label'),
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && !_ctx.form.first_name && _ctx.errors?.first_name }]]),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.first_name) = $event)),
                    placeholder: _ctx.$t('form.first_name.placeholder'),
                    required: ""
                  }, null, 10 /* CLASS, PROPS */, _hoisted_14), [
                    [_vModelText, _ctx.form.first_name]
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.first_name ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.first_name, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" LAST NAME "),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('form.last_name.label')), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    title: _ctx.$t('form.last_name.label'),
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && !_ctx.form.last_name && _ctx.errors?.last_name }]]),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.last_name) = $event)),
                    placeholder: _ctx.$t('form.last_name.placeholder'),
                    required: ""
                  }, null, 10 /* CLASS, PROPS */, _hoisted_18), [
                    [_vModelText, _ctx.form.last_name]
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.last_name ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.last_name, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" REQUEST TYPE "),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('feature.auth.$request_support.request_type')), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && (!_ctx.form.request_type || _ctx.form.request_type === -1) && _ctx.errors?.request_type }]]),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.request_type) = $event)),
                    required: ""
                  }, [
                    _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.$t('form.select_placeholder')), 1 /* TEXT */),
                    (_ctx.labels)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.labels, (label) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: label.id,
                            key: label.id
                          }, _toDisplayString(label.description), 9 /* TEXT, PROPS */, _hoisted_23))
                        }), 128 /* KEYED_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */), [
                    [_vModelSelect, _ctx.form.request_type]
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.request_type ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.request_type, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" MESSAGE "),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('form.message.label')), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("textarea", {
                    title: _ctx.$t('form.message.label'),
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && !_ctx.form.message && _ctx.errors?.message }]]),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.message) = $event)),
                    placeholder: _ctx.$t('form.message.placeholder'),
                    required: "",
                    rows: "6"
                  }, null, 10 /* CLASS, PROPS */, _hoisted_27), [
                    [_vModelText, _ctx.form.message]
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.message ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.message, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "default-btn transition fw-medium fs-md-15 fs-lg-16 d-block w-100",
                      type: "submit",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.setPristine && _ctx.setPristine(...args)))
                    }, _toDisplayString(_ctx.$t('cta.submit')), 1 /* TEXT */))
                  : (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 1 })),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_router_link, {
                    to: "/login",
                    class: "link-btn text-decoration-none fw-medium fs-md-15 fs-lg-16 position-relative"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_30,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.back_to_login')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ], 32 /* NEED_HYDRATION */)
            ])
          ])
        ])
      ]),
      _createCommentVNode(" ERROR MESSAGE "),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
              "aria-label": "Close"
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_AlertModal, {
      id: "alertModal",
      title: _ctx.$t('feature.auth.request_support'),
      dismissible: false,
      message: _ctx.$t('feature.auth.$request_support.success_message'),
      onConfirm: _ctx.redirect
    }, null, 8 /* PROPS */, ["title", "message", "onConfirm"])
  ], 64 /* STABLE_FRAGMENT */))
}